import { setRuntimeConfig } from 'helpers/runtimeConfig';
import * as Sentry from '@sentry/react';

export const prefix = 'REACT_APP_';
const defaultEnvs = {};
const url = new URL(process.env.REACT_APP_CONFIG_API_URL);
url.pathname = '/v2/login/get_configuration';

const initializer = async () => {
  try {
    const data = await (await fetch(url.toString())).json();

    const env = Object.entries(data).reduce((acc, [k, v]) => {
      const key = `${prefix}${k}`;

      acc[key] = defaultEnvs[k] || v;

      return acc;
    }, {});
    setRuntimeConfig('env', env);
  } catch (e) {
    Sentry.captureMessage('Server config load failed', {
      level: 'warning',
      tags: { source: 'SERVER_CONFIG' },
      extra: {
        cause: e,
      },
    });
    throw new Error('Failed to get envs', { cause: e });
  }
};

export default initializer;
